import { UnsupportedUploadMediaKind } from '@/analytics/enums/unsupported-upload.enums'
import { AnalyticsEvent, type AnalyticsEventProperties } from '@/analytics/schema/events.schema'

const SAFE_FILE_EXTENSION = /^\.[a-z0-9]{1,10}$/

const IMAGE_EXTENSIONS = new Set(['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.heic', '.heif', '.tif', '.tiff', '.svg', '.ico', '.avif', '.jfif'])
const VIDEO_EXTENSIONS = new Set(['.mp4', '.mov', '.avi', '.mkv', '.webm', '.m4v', '.wmv', '.flv', '.mpeg', '.mpg', '.3gp'])
const AUDIO_EXTENSIONS = new Set(['.mp3', '.wav', '.aac', '.m4a', '.flac', '.ogg', '.wma', '.aiff', '.opus'])

export function getUnsupportedUploadFileExtension(filename: string): string {
  const base = filename.split(/[/\\]/).pop() ?? filename
  const dot = base.lastIndexOf('.')
  if (dot <= 0 || dot === base.length - 1) return 'none'

  const extension = `.${base.slice(dot + 1).toLowerCase()}`
  return SAFE_FILE_EXTENSION.test(extension) ? extension : 'unknown'
}

export function resolveUnsupportedUploadMediaKind(params: { fileExtension: string; mimeType: string }): UnsupportedUploadMediaKind {
  const mimeType = params.mimeType.trim().toLowerCase()
  if (mimeType.startsWith('image/')) return UnsupportedUploadMediaKind.Image
  if (mimeType.startsWith('video/')) return UnsupportedUploadMediaKind.Video
  if (mimeType.startsWith('audio/')) return UnsupportedUploadMediaKind.Audio

  const extension = params.fileExtension.toLowerCase()
  if (IMAGE_EXTENSIONS.has(extension)) return UnsupportedUploadMediaKind.Image
  if (VIDEO_EXTENSIONS.has(extension)) return UnsupportedUploadMediaKind.Video
  if (AUDIO_EXTENSIONS.has(extension)) return UnsupportedUploadMediaKind.Audio
  return UnsupportedUploadMediaKind.Other
}

export function getUnsupportedTypeRejectedAnalyticsProps(params: {
  filename: string
  mimeType: string
}): AnalyticsEventProperties[AnalyticsEvent.UserFileUnsupportedTypeRejected] {
  const fileExtension = getUnsupportedUploadFileExtension(params.filename)
  return {
    fileExtension,
    mediaKind: resolveUnsupportedUploadMediaKind({ fileExtension, mimeType: params.mimeType }),
  }
}
